import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { dispatchEvent } from 'src/helpers/tagManager'
import { Button, If, Unless, StatusIcon } from 'src/Components'
import { selectCurrentMarketTemperatureIndex } from 'src/store/selectors/marketRecord'
import { ViewMarketSpotlight } from 'src/constants/trackingEvents'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import history from 'src/history'

import MarketSpotlightText from './MarketSpotlightText'
import styles from './MarketSpotlightNavigator.module.scss'

export const MarketSpotlightNavigator = ({ locked }) => {
  const index = useSelector(selectCurrentMarketTemperatureIndex)
  const dataReady = typeof index === 'number'

  const handleClick = () => {
    if (!locked) {
      dispatchEvent(ViewMarketSpotlight)
      history.push(OVERLAY_HELPERS.marketSpotlight.buildPath())
    }
  }

  return (
    <div className={styles.wrapper}>
      <If condition={dataReady}>
        <MarketSpotlightText />
        <Button
          data-qa='take-a-look-btn'
          minimal
          className={styles.moreDetails}
          onClick={handleClick}
        >
          <FormattedMessage
            id='MarketSpotlight.navigator.look'
            defaultMessage='Take a look'
          />
        </Button>
      </If>
      <Unless condition={dataReady}>
        <StatusIcon spin />
      </Unless>
    </div>
  )
}

MarketSpotlightNavigator.propTypes = {
  locked: PropTypes.bool
}

export default MarketSpotlightNavigator
